var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg90X90Key = function Svg90X90Key(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 37,
    x: 11.5,
    y: 37.5,
    stroke: "#000",
    strokeWidth: 3,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M54.1 37.833c-2.221-4.305-4.583-13.416 3.75-15.416 10.417-2.5 12.084-6.25 12.5-10.417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 43h16v6H17zm20 0h6v6h-6zm10 0h6v6h-6zM17 53h6v6h-6zm10 0h6v6h-6zm10 0h6v6h-6zm10 0h6v6h-6zm10 0h6v6h-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M57 43v6h10v10h6V43H57Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 63h6v6h-6zm10 0h36v6H27zm40 0h6v6h-6z"
  })));
};
export default Svg90X90Key;